var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoaCoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7823_3538)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7823_3538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 30.0002V13.1002L26 11.3002V30.0002H6V11.2002L4 13.0002V30.0002C4 31.1002 4.9 32.0002 6 32.0002H26C27.1 32.0002 28 31.1002 28 30.0002Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 11.2001L6.79999 10.5001L16 2.0001L25.2 10.5001L26 11.2001L28 13.0001L30.3 15.1001C30.7 15.5001 31.3 15.5001 31.7 15.0001C32.1 14.6001 32 14.0001 31.6 13.6001L17.4 0.500098C16.6 -0.199902 15.4 -0.199902 14.7 0.500098L0.299989 13.8001C-0.100011 14.2001 -0.100011 14.8001 0.199989 15.2001C0.399989 15.4001 0.699989 15.5001 0.899989 15.5001C1.09999 15.5001 1.39999 15.4001 1.59999 15.2001L3.99999 13.1001L5.99999 11.2001Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 23H10C9.4 23 9 23.4 9 24C9 24.6 9.4 25 10 25H22C22.6 25 23 24.6 23 24C23 23.4 22.6 23 22 23Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13H10C9.4 13 9 13.4 9 14C9 14.6 9.4 15 10 15H22C22.6 15 23 14.6 23 14C23 13.4 22.6 13 22 13Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18H10C9.4 18 9 18.4 9 19C9 19.6 9.4 20 10 20H22C22.6 20 23 19.6 23 19C23 18.4 22.6 18 22 18Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7823_3538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7823_3538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoaCoa);
export default __webpack_public_path__ + "static/media/hoa_coa.33da9cc6c38be6c07aec4c6ef2e56337.svg";
export { ForwardRef as ReactComponent };